import MenuItem from '@mui/material/MenuItem';
import makeStyles from '@mui/styles/makeStyles';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import clsx from 'clsx';
import { useContext } from 'react';
import NRAssetsActionsStyles from '../NRAssetsActions/NRAssetsActions.styles';
import { NRMenu } from '../../components/NRMenu/NRMenu';
import NRGroupIcon from '../../NRIcons/NRGroupIcon';
import Typography from '@mui/material/Typography';
import { SBOMContext } from '../../pages/NRSBOMTable/NRSBOMDataShare';

const useStyles = makeStyles(NRAssetsActionsStyles);

function NRSBOMActions({ anchorEl, setAnchorEl, onMenuClose, handleEditClick, removeDisabled = false }) {
  const open = Boolean(anchorEl);
  const classes = useStyles();
  const { setOpenRemoveModal } = useContext(SBOMContext);

  const handleMenuClose = () => {
    setAnchorEl(null);
    !!onMenuClose && onMenuClose();
  };

  const handleOpenModal = () => {
    setOpenRemoveModal(true);
  };

  return (
    <div>
      <NRMenu
        id="demo-customized-menu"
        MenuListProps={{
          'aria-labelledby': 'actions-button'
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
      >
        {!!handleEditClick && (
          <MenuItem onClick={handleEditClick} disableRipple className={clsx(classes.item, classes.firstItem)} disabled={removeDisabled}>
            <ModeEditOutlineOutlinedIcon />
            Modify Component
          </MenuItem>
        )}
        <MenuItem
          onClick={handleOpenModal}
          disableRipple
          className={clsx(classes.item, classes.groupsIcon, { [classes.firstItem]: !handleEditClick })}
          disabled={removeDisabled}
        >
          <NRGroupIcon width={'24'} height={'24'} />
          <Typography sx={{ pl: 1.5 }}>Remove Component</Typography>
        </MenuItem>
      </NRMenu>
    </div>
  );
}
export default NRSBOMActions;
